import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-flex-job-info-summary',
  templateUrl: './flex-job-info-summary.component.html',
  styleUrls: ['./flex-job-info-summary.component.scss'],
})
export class FlexJobInfoSummaryComponent {
  howItWorksItems = [
    { icon: 'clipboard', label: 'Post a job starting in the next 4-48 hours' },
    { icon: 'notifications', label: 'Nearby Last Minute workers are notified in real-time' },
    { icon: 'people', label: 'You will receive offers from up to 5 workers who are available and interested' },
    { icon: 'checkmark-circle', label: 'Accept a worker’s offer at least 2 hours before the job start time' },
  ];

  @HostBinding('class.isTile') @Input() isTile = false;
}
